import styled from "styled-components";
import { HomePageWrapper as BaseWrapper } from "../../../../Domain/HomePage/HotelPage.style";

export const HotelHomeWrapper = styled(BaseWrapper)`
  --pou-blue-hero: #37a7cd;
  --pou-blue-light: #25a6ff;
  --pou-bg-dark: #ffffff;
  --pou-bg-footer: #f2f2f2;
  --pou-text-on-blue: #ffffff;
  --pou-text-default: #ffffff;
  --pou-border-light: #d8d8d8;
  --pou-search-btn: #8db906;

  background-color: var(--pou-bg-dark);

  .scroll-full {
    background: var(--pou-bg-dark);
  }

  .hotel-hero {
    position: relative;
    background-color: var(--pou-blue-hero);
    color: var(--pou-text-on-blue);
    padding: 56px 16px 68px;
    text-align: center;
  }

  .hotel-hero__content {
    position: relative;
    z-index: 1;
    max-width: 1120px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 24px;
    align-items: center;
  }

  .hotel-hero__title {
    margin: 0;
    font-weight: 400;
    line-height: 1.15;
    font-size: 28px;
    letter-spacing: -0.01em;
  }

  .hotel-hero__search {
    width: min(1080px, 100%);
  }

  .hotel-main {
    /* background: var(--pou-bg-dark); */
    color: var(--pou-text-default);
    padding: 48px 16px 0;
  }

  .hotel-section {
    padding: 0 0 60px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .section-heading {
    padding-bottom: 22px;
    max-width: 1100px;
    margin: 0 auto;
    text-align: center;

    h2 {
      margin: 0;
      color: var(--pou-blue-light);
      font-weight: 800;
      font-size: clamp(23px, 3vw, 26px);
    }

    .subtitle {
      margin-top: 6px;
      color: #cfd6dd;
      font-size: 15px;
    }
  }

  .gallery-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    max-width: 1100px;
    margin: 0 auto;
  }

  .blue-color {
    color: var(--pou-blue-light);
  }

  .gallery-card {
    position: relative;
    display: block;
    background: #0b0b0b;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 18px 38px rgba(0, 0, 0, 0.3);
    transition:
      transform 0.25s ease,
      box-shadow 0.25s ease;

    &:hover {
      transform: translateY(-6px) scale(1.01);
      box-shadow: 0 28px 56px rgba(0, 0, 0, 0.45);
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      aspect-ratio: 16 / 9;
      filter: brightness(0.92);
    }

    &__overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.7) 100%
      );
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 14px 16px;
      gap: 6px;
    }

    &__label {
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      text-shadow: 0 1px 8px rgba(0, 0, 0, 0.6);
    }

    &__subtitle {
      font-size: 14px;
      color: #e0e6ed;
    }
  }

  @media (max-width: 900px) {
    .gallery-grid {
      grid-template-columns: 1fr;
    }

    .hotel-main {
      padding: 40px 12px 0;
    }
    .section-heading h2 {
      font-size: 22px;
    }
  }

  @media (max-width: 700px) {
    .hotel-hero {
      padding: 40px 12px 48px;
    }

    .hotel-hero__content {
      gap: 18px;
    }

    .hotel-hero__title {
      font-size: 28px;
    }

    .gallery-grid {
      gap: 14px;
    }
  }
`;
